import axios from 'axios'
import { useEffect, useState } from 'react'

export function useDatabase() {
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState([])

  async function fetch() {
    setIsLoading(true)

    try {
      const res = await axios.get('/api/databases')

      const databases = res.data.databases
      if (!databases) return

      setData(databases)
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetch()
  }, [])

  return { data: data, reload: fetch, isLoading }
}
